<script>
import resources from '../advanced/resources'

export default {
  name: 'agenda-search-professional',
  data () {
    return {
      force_speciality: false,
      force_professional: true,
      agenda: {
        location: {
          distance: null
        }
      }
    }
  },
  mixins: [resources]
}
</script>

<template lang="pug">
page
  h2(slot="title")
    span.first-line
      span.icon 
      |  Encontre um Profissional pelo Nome
  .col-xs-12.content
    .container-fluid
      .row
        .nav-tabs-wrapper
          search-options
        .col-xs-12.white-bg
          .row
            .col-xs-12
              form.col-sm-10
                .form-group(style='padding:30px 0px;')
                  .row
                  .form-group(:class="{'has-error is-empty': $v.agenda.professional.id.$error}")
                    f-select-professional(
                      v-model="agenda.professional.id",
                      label="Nome do Profissional",
                      @selected="onSelectedProfessional")
                    p.help-block(v-if='$v.agenda.professional.id.$error')
                      strong(v-if='!$v.agenda.professional.id.required')
                        | Informe o nome do profissional
                  .form-group
                    f-select(
                      v-model="agenda.level_id",
                      :options="levelOptions",
                      label="Qual o nível de urgência")

                    .form-group(style='margin-top:30px;', v-if="agenda.level_id === 'others'")
                      .row
                        .col-xs-12.col-sm-4
                          label Data início
                          v-datepicker(
                            name="valid_to_end",
                            v-model="agenda.date_start",
                            :config='config')

                        .col-xs-12.col-sm-4
                          label Data fim
                          v-datepicker(
                            name="valid_to_end",
                            v-model="agenda.date_end",
                            :config='config')

                        .col-xs-12.col-sm-4
                          f-select(label="Período", v-model="agenda.period", :options="periodOptions")
                    .buttons-wrapper
                      button.btn.save(@click.prevent="doLoad()")
                        span.icon 
                        |  Encontrar Profissional
</template>



// WEBPACK FOOTER //
// src/app/patient/agendas/search/professional/agenda.vue